import Button from '../base/Button'

interface Plan {
  speed: string
  price: number
  originalPrice: number
  discount: number
  features: string[]
  popular?: boolean
}

export default function PlansSection () {
  const plans: Plan[] = [
    {
      speed: '600',
      price: 99.9,
      originalPrice: 119.9,
      discount: 20,
      features: [
        'Download e Upload até 600 Mbps',
        '100% Fibra Óptica',
        'Wi-Fi 6 incluso',
        'Suporte 24/7',
        'Instalação gratuita'
      ]
    },
    {
      speed: '850',
      price: 129.9,
      originalPrice: 149.9,
      discount: 20,
      features: [
        'Download e Upload até 850 Mbps',
        '100% Fibra Óptica',
        'Wi-Fi 6 incluso',
        'Suporte 24/7',
        'Instalação gratuita'
      ],
      popular: true
    },
    {
      speed: '1000',
      price: 169.9,
      originalPrice: 189.9,
      discount: 20,
      features: [
        'Download e Upload até 1 Gbps',
        '100% Fibra Óptica',
        'Wi-Fi 6 Pro incluso',
        'Suporte 24/7',
        'Instalação gratuita'
      ]
    }
  ]

  return (
    <section id='planos' className='py-20 bg-gray-50'>
      <div className='container mx-auto px-4'>
        <div className='text-center mb-16'>
          <h2 className='text-4xl md:text-5xl font-bold text-gray-900 mb-6'>
            Escolha o Plano <span className='text-orange-600'>Ideal</span>
          </h2>
          <p className='text-xl text-gray-600 max-w-3xl mx-auto'>
            Todos os nossos planos incluem desconto de R$ 20,00 para pagamento
            em dia. Internet 100% fibra óptica com a melhor velocidade da
            região.
          </p>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto'>
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-xl overflow-hidden transform hover:scale-105 transition-all duration-300 ${
                plan.popular ? 'ring-4 ring-orange-500 ring-opacity-50' : ''
              }`}
            >
              {plan.popular && (
                <div className='absolute top-0 left-0 right-0 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-center py-2 font-semibold'>
                  Mais Popular
                </div>
              )}

              <div className={`p-8 ${plan.popular ? 'pt-16' : ''}`}>
                <div className='text-center mb-8'>
                  <div className='text-6xl font-bold text-purple-900 mb-2'>
                    {plan.speed}
                    <span className='text-2xl text-gray-600'>MB</span>
                  </div>

                  <div className='mb-4'>
                    <div className='text-sm text-gray-500 line-through'>
                      De R$ {plan.originalPrice.toFixed(2).replace('.', ',')}
                    </div>
                    <div className='text-4xl font-bold text-orange-600'>
                      R$ {plan.price.toFixed(2).replace('.', ',')}
                      <span className='text-lg text-gray-600'>/mês</span>
                    </div>
                    <div className='text-sm text-green-600 font-semibold'>
                      Economia de R$ {plan.discount},00 no pagamento em dia
                    </div>
                  </div>
                </div>

                <ul className='space-y-4 mb-8'>
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className='flex items-center'>
                      <i className='ri-check-line text-green-500 text-xl mr-3'></i>
                      <span className='text-gray-700'>{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  variant={plan.popular ? 'primary' : 'secondary'}
                  size='lg'
                  className='w-full'
                  href='http://wa.me/556540420692'
                >
                  <i className='ri-whatsapp-line mr-2'></i>
                  Contratar Agora
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className='text-center mt-12'>
          <div className='bg-white rounded-xl p-6 shadow-lg max-w-2xl mx-auto'>
            <div className='flex items-center justify-center mb-4'>
              <i className='ri-gift-line text-orange-600 text-3xl mr-3'></i>
              <h3 className='text-2xl font-bold text-gray-900'>
                Oferta Especial
              </h3>
            </div>
            <p className='text-gray-700 text-lg'>
              <strong>R$ 20,00 de desconto</strong> em todos os planos para
              clientes que mantêm o pagamento em dia. Aproveite essa
              oportunidade e economize todos os meses!
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
